<form [formGroup]="templateRequestFormGroup" class="d-block container">
  <div class="row">
    <div class="col-md-8 col-12">
      <div class="input-item-edit required"
           [class.error-input]="templateRequestFormGroup.get('userName').status === 'INVALID' && this.templateRequestFormGroup.get('userName').touched">
        <label class="text-uppercase"> {{ translationScope+'.name.label' | transloco }}
        </label>
        <input
          type="text"
          formControlName="userName"
          class="form-control rounded-0"
          [placeholder]="translationScope+'.name.placeholder' | transloco"
          required
        />
      </div>
    </div>

    <div class="col-md-8 col-12">
      <div class="input-item-edit required"
           [class.error-input]="templateRequestFormGroup.get('userEmail').status === 'INVALID' && this.templateRequestFormGroup.get('userEmail').touched">
        <label class="text-uppercase"> {{ translationScope+'.email.label' | transloco }}
        </label>
        <input type="email" formControlName="userEmail" class="form-control rounded-0 text-black"
               [placeholder]="translationScope+'.email.placeholder' | transloco"/>
      </div>
    </div>
    <div class="col-md-8 col-12">
      <div class="input-item-edit required"
           [class.error-input]="templateRequestFormGroup.get('confirmEmail').status === 'INVALID' && this.templateRequestFormGroup.get('confirmEmail').touched">
        <label class="text-uppercase">{{ translationScope+'.confirm_email.label' | transloco }}
        </label>
        <input type="email" formControlName="confirmEmail" class="form-control rounded-0 text-black"
               [placeholder]="translationScope+'.confirm_email.placeholder' | transloco"/>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-12 col-md-4">
      <div class="input-item-edit required"
           [class.error-input]="templateRequestFormGroup.get('courseTemplateId').status === 'INVALID' && this.templateRequestFormGroup.get('courseTemplateId').touched"
      >
        <label class="text-uppercase">
          {{ translationScope+'.wanted_course.label' | transloco }}
        </label>
        <ng-select class="dropdown"
                   [searchable]="true"
                   [placeholder]="translationScope+'.wanted_course.placeholder' | transloco"
                   formControlName="courseTemplateId"
                   [clearable]="false">
          <ng-option *ngFor="let template of templates"
                     [value]="template.id">
            {{ template.title }}
          </ng-option>
        </ng-select>
      </div>
    </div>
    <div class="col-12 col-md-4">
      <div class="input-item-edit required"
           [class.error-input]="templateRequestFormGroup.get('regionId').status === 'INVALID' && this.templateRequestFormGroup.get('regionId').touched">
        <label class="text-uppercase"> {{ translationScope+'.region.label' | transloco }}
        </label>
        <ng-select class="dropdown"
                   [searchable]="true"
                   [placeholder]="translationScope+'.region.placeholder' | transloco"
                   formControlName="regionId"
                   [clearable]="false">
          <ng-option *ngFor="let region of regions"
                     [value]="region.id">
            {{ region.name }}
          </ng-option>
        </ng-select>
      </div>
    </div>
<!--    <div class="col-12 col-md-4">-->
<!--      <div class="input-item-edit">-->
<!--        <label class="text-uppercase">Template Instructors-->
<!--        </label>-->
<!--        <ng-select class="dropdown"-->
<!--                   [searchable]="true"-->
<!--                   [placeholder]="'Please of which instructor you want the course'"-->
<!--                   formControlName="instructorId"-->
<!--                   [clearable]="false">-->
<!--          <ng-option *ngFor="let instructor of instructors"-->
<!--                     [value]="instructor.id">-->
<!--            {{ instructor.firstName + ' ' + instructor.lastName }}-->
<!--          </ng-option>-->
<!--        </ng-select>-->
<!--      </div>-->
<!--    </div>-->
    <div class="col-12 col-md-8">
      <div class="input-item-edit">
        <label class="text-uppercase">
          {{ translationScope+'.comment.label' | transloco }}
        </label>
        <textarea rows="4" formControlName="description" class="form-control rounded-0" [placeholder]="translationScope+'.comment.placeholder' | transloco"></textarea>
      </div>
    </div>
    <div class="col-12 pt-4">
      <button  appCtaBtn [disabled]="templateRequestFormGroup.invalid"
               (click)="submitTemplateRequestForm()"
      >
        {{ 'templatestudent.action_buttons.send_request'  | transloco}}
      </button>
    </div>
  </div>
</form>
